import { FunctionComponent, MouseEvent, useState } from 'react'
import { get } from 'libraries/lodash'
import cx from 'classnames'
import ellipsis from 'text-ellipsis'
import Selector from 'components/accordion/Selector'
import { AccordionHeaderProps, toDataProps } from 'components/accordion/AccordionHeader'
import ContentHeaderLabelContainer from 'redux/containers/components/accordion/ContentHeaderLabelContainer'
import CommentControlsContainer from 'redux/containers/components/accordion/CommentControlsContainer'
import { ContentHeaderContainerProps } from 'redux/containers/components/accordion/ContentHeaderContainer'
import { Flavour } from 'types/Flavour'
import { dismissPopover } from 'services/OverlayService'
import AccordionHeaderToolTip from './AccordionHeaderToolTip'

const ContentHeader:FunctionComponent<ContentHeaderProps> = ({
  atBottom,
  className,
  comments,
  depth,
  id,
  commentsId,
  nodeId,
  prefix,
  selected,
  suffix,
  title = '',
  addComment,
  flavour,
  cxNames,
  isHighlighted = false,
  eventCategory,
  urlNode,
  path,
  expanded,
  handleOnClick
}) => {
  const Suffix = (suffix && <span>{suffix}</span>) || null
  if (!title && !prefix) {
    return (<NoTitle {...{ id, expanded, handleOnClick, addComment, commentsId, comments }} />)
  }
  const backgroundOverride = isHighlighted ? 'highlight-yellow' : get(cxNames, 'contentHeader.headerBackground', '')
  const props = Object.assign(
    { className },
    toDataProps({
      id,
      depth,
      nodeId,
      title: title || '-',
      prefix: prefix || '',
      suffix: suffix || '',
      type: 'content',
      expanded
    })
  )

  if (selected !== undefined) {
    Object.assign(props, toDataProps({ selected }))
  }

  Object.assign(
    props,
    toDataProps({ helpItem: !expanded ? 'accordioncontentcollapsed' : 'accordioncontentexpanded' })
  )

  return (
    <div {...props} className={cx('relative flex items-center justify-between min-h3 w-100', backgroundOverride)}>
      <ContentHeaderLabelContainer {...{ id, nodeId, depth, atBottom, expanded, prefix, title, eventCategory, path }}>
        {prefix && <ContentHeaderPrefix {...{ prefix, depth, nodeId, urlNode }} />}
      </ContentHeaderLabelContainer>
      <CommentControlsContainer {...{ id, expanded, handleOnClick, addComment, commentsId, comments }} />
      <div
        className='mr8'
        onClick={(e) => {
          dismissPopover(e.target)
          e.stopPropagation()
        }}
      >
        <div className='mr4 flex items-center'>
          {Suffix}
          <Selector type='content' {...{ atBottom, id, selected, title, flavour, expanded }} />
        </div>
      </div>
    </div>
  )
}

const ContentHeaderPrefix:FunctionComponent<ContentHeaderPrefixProps> = ({ prefix, depth, nodeId, urlNode }) => {
  const [hover, setHover] = useState(false)
  const maxCharLength = 7
  return (
    <span
      className={cx(
        'absolute mv5 f5 w9',
        { underline: nodeId === urlNode }
      )}
      style={{ marginLeft: `${depth - 1}rem` }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <>
        {prefix.length > maxCharLength && (
          <AccordionHeaderToolTip open={hover} title={prefix} placement='left' arrow>
            <div className='pr4'>
              {ellipsis(prefix, maxCharLength, {side: 'start'})}
            </div>
          </AccordionHeaderToolTip>
        )}

        {prefix.length <= maxCharLength && prefix}
      </>
    </span>
  )
}

const NoTitle:FunctionComponent<NoTitleProps> = ({ id, expanded, handleOnClick, addComment, commentsId, comments }) => (
  <div className='no-title'>
    <CommentControlsContainer {...{ id, expanded, handleOnClick, addComment, comments, commentsId }} />
  </div>
)

interface ContentHeaderPrefixProps {
  prefix: string;
  depth:number;
  nodeId: string;
  urlNode: string;
}

interface NoTitleProps {
  id: string;
  expanded: boolean;
  handleOnClick: (e: MouseEvent) => void;
  comments: any[];
  addComment: any; // FIX ME
  commentsId:string;
}

export interface ContentHeaderProps extends ContentHeaderContainerProps, AccordionHeaderProps{
  nodeId: string;
  title?:string;
  flavour?:Flavour
  urlNode: string;
}

export default ContentHeader
